const individualTaxReportUrlGetter = (state) => state.reports.tax;

export const individualTaxReportUrlSelector = (state) => ({
  reports: {
    tax: individualTaxReportUrlGetter(state)
  }
});
